import { Editor, Node, type Path, Transforms } from 'slate';

// Removes the node at path along with any ancestors that would become empty.
const removeTree = (editor: Editor, path: Path) => {
  const ancestors = Array.from(
    Node.ancestors(editor, path, {
      reverse: true,
    })
  );

  let pathToRemove = path;
  for (const [ancestor, ancestorPath] of ancestors) {
    if (Editor.isEditor(ancestor)) continue;

    const children = Array.from(Node.children(editor, ancestorPath));
    // Move up the tree until we find a block with more than one child.
    if (children.length > 1) {
      break;
    } else {
      // Ancestors with only 1 child can be removed, as they
      // ultimately only contain the block that will be removed.
      pathToRemove = ancestorPath;
    }
  }
  Transforms.removeNodes(editor, { at: pathToRemove });
};

export default removeTree;
